import React from 'react';
import styles from './CheckBox.module.scss';
import classNames from 'classnames';

interface CheckBoxCardProps {
	id: number | string;
	htmlId?: string;
	className?: string;
	icon: React.ReactNode;
	title: string;
	desc: string;
	isChecked?: boolean;
	onChange?: (id: number | string, checked: boolean) => void;
}

const CheckBoxCard: React.FC<CheckBoxCardProps> = ({
	id,
	htmlId,
	className = '',
	icon,
	title,
	desc,
	isChecked = false,
	onChange
}) => {
	const handleToggle = () => {
		onChange?.(id, !isChecked);
	};

	return (
		<div
			id={htmlId}
			className={classNames(styles.checkboxCard, className, {
				[styles['checkboxCard--checked']]: isChecked
			})}
			onClick={handleToggle}
		>
			<div className={styles.checkbox}>
				<input
					type="checkbox"
					checked={isChecked}
					onChange={handleToggle}
					onClick={(e) => e.stopPropagation()}
				/>
				<span className={styles.checkmark}>
					{isChecked && (
						<svg
							width="12"
							height="10"
							viewBox="0 0 12 10"
							fill="none"
						>
							<path
								d="M1 5L4.5 8.5L11 1"
								stroke="white"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</span>
			</div>
			<div className={styles.content}>
				<div className={styles.header}>
					<span className={styles.iconWrap}>{icon}</span>
					<span className={styles.title}>{title}</span>
				</div>
				{desc && <div className={styles.description}>{desc}</div>}
			</div>
		</div>
	);
};

export default CheckBoxCard;
